import axios from "axios";
import { getConfig } from "common/config";
import {
  applyCustomerContextHeaders,
  attachCustomerHeaderOmissionInterceptor,
  clearCustomerContextHeaders,
} from "./CustomerContextHeaders";
import {
  applyRequestAuthHeader,
  createUnauthorizedResponseHandler,
} from "./httpAuthInterceptors";

const base_url = getConfig("REACT_APP_BASE_URL");

const httpClient = axios.create({
  baseURL: base_url,
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const setDefaultAuthorization = (token) => {
  httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
};

httpClient.interceptors.request.use(
  (config) => applyRequestAuthHeader(config, setDefaultAuthorization),
  (error) => Promise.reject(error)
);

attachCustomerHeaderOmissionInterceptor(httpClient);

httpClient.interceptors.response.use(
  (response) => response,
  createUnauthorizedResponseHandler(httpClient, setDefaultAuthorization)
);

const setAuthToken = (token) => {
  if (!token) {
    delete httpClient.defaults.headers.common.Authorization;
    clearCustomerContextHeaders();
    return;
  }
  httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const setTokenToHeader = (userid, token, customerCode) => {
  setAuthToken(token);
  if (!token) {
    return;
  }
  if (customerCode && userid) {
    applyCustomerContextHeaders(userid, customerCode);
  }
};

const changeHeaderToken = (userId, customerCode) => {
  if (customerCode == null || String(customerCode).trim() === "") {
    clearCustomerContextHeaders();
    return;
  }
  const resolvedUserId =
    userId ?? httpClient.defaults.headers.common["user-id"];
  applyCustomerContextHeaders(resolvedUserId, customerCode);
};

export {
  base_url,
  httpClient,
  setAuthToken,
  setTokenToHeader,
  changeHeaderToken,
  clearCustomerContextHeaders,
  applyCustomerContextHeaders,
};
